<template>
  <div v-if="!flag">
    <xo-loader :type="'cube'" :color="['#ff3634']" :size="{width: '32px', height: '32px'}" :font="{fontSize: '12px'}" :text="'页面跳转中...'"></xo-loader>
  </div>
</template>
<script>
  import utils from '@/utils'
  import { mapActions } from 'vuex'
  import { getCookie } from '@/store/cookies'
  export default {
    data () {
      return {
        flag: false
      }
    },
    created () {
      var expired = utils.getQueryString('expired')
      var token = getCookie('token')
      if (token) { // 已登录
        this.flag = true
        this.toIndex(false)
      } else { // 未登录/token过期
        if (expired) { // token过期
          this.toIndex(true)
        } else { // 未登录
          this.flag = true
          this.toIndex(false)
        }
      }
    },
    methods: {
      ...mapActions('auth', ['getBusinessIdByCode', 'toOtherDomain']),
      toIndex (toRefresh) {
        var domain = utils.getQueryString('domain')
        var t = (toRefresh) ? 2000 : 0
        setTimeout(() => {
          this.getBusinessIdByCode(domain).then((r) => {
            this.flag = true
            if (r) {
              let o = $.extend(true, {}, r[0]); // 深复制对象
              o.toRefresh = toRefresh
              this.toOtherDomain(o)
            } else {
              let o = {domain: 'inesa.byl.sh.cn', businessId: ''}
              o.toRefresh = toRefresh
              this.toOtherDomain(o)
            }
          })
        }, t)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/reload.vue